import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import 'uno.css'
import '@scss/normalized.scss'
import 'nprogress/nprogress.css' // progress bar style

import { Boot } from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'

// 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册。
Boot.registerModule(attachmentModule)

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
